import { POST, GET } from "../method.js";
import { ENDPOINTS } from "../ApiConstants.js"

export const sendOTP = async (data) => {
	const url = ENDPOINTS.OTP_VALIDATION
	return POST(url, data);
};

export const resendOTP = async (data) => {
	const url = ENDPOINTS.RESEND_OTP
	return POST(url, data);
};

export const loginAPI = async (data) => {
	const url = ENDPOINTS.LOGIN;
	return POST(url, data);
};

export const validateBinNumber = async (bin) => {
	const url = ENDPOINTS.VALIDATION_BIN(bin)
	return GET(url);
}

export const signUpAPI = async (data) => {
	const url = ENDPOINTS.SIGNUP;
	return POST(url, data);
};

export const UidSignUpAPI = async (data) => {
	const url = ENDPOINTS.UID_SIGNUP;
	return POST(url, data);
};